<template>
    <div>
        <div>
            <nav class="navbar navbar-expand-lg navbar-light">
                <div class="ml-auto">
                    <form class="form-inline my-2 my-lg-0">
                        <input
                                class="form-control mr-sm-2"
                                type="text"
                                placeholder="เดือน"/>
                        <input
                                class="form-control mr-sm-2"
                                type="text"
                                placeholder="ปี"/>
                        <button
                                class="btn btn-success my-2 my-sm-0"
                                type="button">
                            <icon name="search"></icon>
                            ค้นหา
                        </button>&nbsp
                        <button class="btn btn-warning my-2 my-sm-0"
                                @click="goToRealizedForm"
                                type="button">
                            <icon name="plus"></icon>
                            สร้างรายการกำไร - ขาดทุน
                        </button>&nbsp
                    </form>
                </div>
            </nav>
        </div>
        <!--<pre class="alert-success">{{month}} {{year}}</pre>-->
    </div>
</template>

<script>
    export default {
        name: "realized-gain-loss-list",
        data(){
          return {
              month : "",
              year : ""
          }
        },
        created(){
            this.getCurrentMonthYear();
        },
        methods:{
            goToRealizedForm(){
                this.$store.dispatch("RealizedGainLoss/getRealizedGainLossPerMonth",{
                   month : this.month,
                   year : this.year
                });
                this.$router.push("/realized-gain-loss-form");
            },
            getCurrentMonthYear(){
                this.month = new Date().getMonth() + 1;
                this.year = new Date().getFullYear();
            },
        }
    }
</script>

<style scoped>

</style>